import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import {
    ForgetPasswordEmail,
    VerifyOTP,
    ResetPassword,
} from '../../containers';
import DashboardLayout from '../../components/Layout/dashboardLayout.jsx';
import AppRoutes from './AppRoutes';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Signin from '../../containers/SignIn/index.js';
import AuthLayout from '../../components/Layout/authLayout.jsx';
import { ConfigProvider, Spin } from 'antd';
import CompanyOnboarding from '../../containers/Onboarding/CompanyOnboarding/index.js';
import { DEFAULT_USER_COLORS } from '../colors/index.js';
import AppAction from '../../store/actions/AppAction.js';
import { Utils } from '../index.js';
import { verifyCompany } from '../getApis/index.js';

const LogoutRedirect = () => {
    useEffect(() => {
        window.location.replace(Utils.getPublicOnboardingUrl());
    }, []);

    return (
        <div className="flex items-center justify-center w-full h-screen">
            <Spin />
        </div>
    );
};

const AuthRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [isCompanyUrlValid, setIsCompanyUrlValid] = useState(false); // Track validity

    const user = useSelector((state) => state.AppReducer?.user);
    const guardCompany = useSelector(
        (state) => state.AppReducer?.user?.guardCompany,
    );
    const validCompany = useSelector(
        (state) => state?.AppReducer?.validCompany,
    );

    useEffect(() => {
        const companyUrl = Utils.getCompanyUrlFromHostname();
        const currentPath = location.pathname;

        const validateCompanyUrl = async (requestedCompanyUrl) => {
            setLoading(true);
            const result = await verifyCompany(requestedCompanyUrl);
            if (result instanceof Error) {
                Utils.showMessage('error', result?.response?.data?.message);
                window.location.replace(Utils.getPublicOnboardingUrl());
                setIsCompanyUrlValid(false);
                setLoading(false);
            } else {
                dispatch(AppAction.ValidCompany(result));
                localStorage.setItem('companyData', JSON.stringify(result));
                setIsCompanyUrlValid(true);
                setLoading(false);
            }
        };

        if (currentPath === '/logout') {
            setLoading(false);
            return;
        }

        if (companyUrl) {
            validateCompanyUrl(companyUrl);
            return;
        }

        if (currentPath !== '/onboard-company') {
            window.location.replace(Utils.getPublicOnboardingUrl());
            return;
        }

        setLoading(false);
    }, [dispatch, location.pathname]);

    useEffect(() => {
        if (location.pathname === '/login' && user?.token) {
            navigate('/');
        } else if (
            isCompanyUrlValid &&
            location.pathname === '/' &&
            !user?.token
        ) {
            navigate('/login');
        }
    }, [isCompanyUrlValid, location.pathname, user?.token, navigate]);

    // if (!isCompanyUrlValid) {
    //     return (
    //         <div className="flex items-center justify-center w-full h-screen">
    //             <div>
    //                 <h2>{errorMessage}</h2>
    //             </div>
    //         </div>
    //     ); // Show error message
    // }

    return (
        <div className="App">
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary:
                            guardCompany?.primaryColour ??
                            validCompany?.primaryColour ??
                            DEFAULT_USER_COLORS.primaryColour,
                        colorSecondary:
                            guardCompany?.secondaryColour ??
                            validCompany?.secondaryColour ??
                            DEFAULT_USER_COLORS.secondaryColour,
                        colorAccent:
                            guardCompany?.primaryColour ??
                            validCompany?.primaryColour ??
                            DEFAULT_USER_COLORS.primaryColour,
                        colorLink:
                            guardCompany?.primaryColour ??
                            validCompany?.primaryColour ??
                            DEFAULT_USER_COLORS.primaryColour,
                        colorTextBase:
                            guardCompany?.textColour ??
                            validCompany?.textColour ??
                            DEFAULT_USER_COLORS.textColour,
                    },
                    components: {
                        fontFamily: '"Gilroy", sans-serif',
                    },
                }}
            >
                {!user?.token ? (
                    loading ? (
                        <div className="flex items-center justify-center w-full h-screen">
                            <Spin />
                        </div>
                    ) : (
                        <Routes>
                            <Route element={<AuthLayout />}>
                                <Route path="/login" element={<Signin />} />
                                <Route
                                    path="/onboard-company"
                                    element={<CompanyOnboarding />}
                                />
                                <Route
                                    path="/forgot-password"
                                    element={<ForgetPasswordEmail />}
                                />
                                <Route
                                    path="/verify-password"
                                    element={<VerifyOTP />}
                                />
                                <Route
                                    path="/reset-password"
                                    element={<ResetPassword />}
                                />
                            </Route>
                            <Route
                                path="/auth-layout"
                                element={<AuthLayout />}
                            />

                            <Route
                                path="/logout"
                                element={<LogoutRedirect />}
                            />

                            <Route
                                path="*"
                                element={<Navigate to="/login" />}
                            />
                        </Routes>
                    )
                ) : (
                    <DashboardLayout expandible={false}>
                        <AppRoutes isRole={user?.userRole[0]} />
                    </DashboardLayout>
                )}
            </ConfigProvider>
        </div>
    );
};

export default AuthRoutes;
